import {
  all, put, select, spawn, takeEvery
} from "redux-saga/effects";
import { deleteProject } from "Workers/Projects";
import {
  projectDeleteSuccess,
  projectsDeleteError,
  projectsDeleteNext,
  projectsDeleteStart,
  projectsDeleteSuccess,
  uiSetActiveProjectId,
  uiSetDetailsOpen
} from "../Actions";
import { selectDeletingProjectId } from "../Selectors/Delete";
import { selectIsDetailsOpen, selectSelectedProjectsCount } from "../Selectors/UI";
import { callWithAuth } from "./CallWithAuth";
import { sortAndFilterSaga } from "./Projects";

function* deleteProjectSaga() {
  try {
    const [isDetailsOpen, deletingProjectId, selectedProjectsCount]: [boolean, string, number] = yield all([
      select(selectIsDetailsOpen),
      select(selectDeletingProjectId),
      select(selectSelectedProjectsCount)
    ]);

    if (isDetailsOpen) {
      yield all([put(uiSetDetailsOpen(false)), put(uiSetActiveProjectId(null))]);
    }

    yield callWithAuth(deleteProject, deletingProjectId);
    yield put(projectDeleteSuccess(deletingProjectId));

    if (selectedProjectsCount <= 1 || isDetailsOpen) {
      yield all([put(projectsDeleteSuccess()), spawn(sortAndFilterSaga, { sort: false })]);
      return;
    }

    yield put(projectsDeleteNext());
  } catch (e) {
    console.error(e);
    if (e?.message?.includes(`No project found`)) {
      yield put(projectsDeleteError({ text: `delete.421` }));
      return;
    }

    yield put(projectsDeleteError({ text: `delete.420` }));
  }
}

export function* DeleteSaga() {
  yield takeEvery([projectsDeleteStart, projectsDeleteNext], deleteProjectSaga);
}
